/**
 * Every API path the web app calls, in one place — matched to L2's routers
 * (api/src/app.ts: /api/auth, /api/schema, /api (registry), /api/export).
 * Paths are relative to the `/api` base in client.ts.
 */
export const endpoints = {
  me: '/auth/me',
  devUsers: '/auth/dev-users',
  devLogin: '/auth/dev-login',
  logout: '/auth/logout',
  /** One metadata document for every entity type; the client joins bindings itself. */
  schema: '/schema',
  entities: '/entities',
  entity: (id: string) => `/entities/${id}`,
  entityAttribute: (id: string, code: string) => `/entities/${id}/attributes/${encodeURIComponent(code)}`,
  entityHistory: (id: string) => `/entities/${id}/history`,
  views: (entityType: string) => `/views?type=${encodeURIComponent(entityType)}`,
  view: (id: string) => `/views/${id}`,
  createView: '/views',
  /** #223: a shared view is configuration — its writes are CC-1 proposals on their own routes. */
  sharedViews: '/views/shared',
  sharedView: (id: string) => `/views/shared/${id}`,
  exportXlsx: '/export/registry.xlsx',
} as const;
